// extracted by mini-css-extract-plugin
export var attribution = "styles-module--attribution--14364";
export var card = "styles-module--card--4bf96";
export var columns = "styles-module--columns--55b38";
export var heading = "styles-module--heading--04f34";
export var icon = "styles-module--icon--97dbd";
export var secondary = "styles-module--secondary--5917e";